



































































import { Vue, Component, Inject, Prop } from "vue-property-decorator";
import {
  ITimelineProvider,
  ITimelineProviderMethods
} from "@/models/providers/timeline";

@Component({
  components: {
    "event-message": () =>
      import("@/components/app/global/timelineComponent/eventMessage.vue")
  }
})
export default class TimelineEvent extends Vue {
  // Injected
  @Inject({ from: "timelineProviderMethods" })
  public readonly $timelineMethods!: ITimelineProviderMethods;

  @Inject({ from: "timelineProvider" })
  public readonly $timelineData!: () => ITimelineProvider;

  // Props
  @Prop({ required: true })
  public event!: any;

  @Prop({ required: true })
  public prevEvent!: any;

  @Prop({ required: true })
  public nextEvent!: any;

  // Lifecycle hooks
  public created() {
    if (this.isPrevSame && this.timelineData.isStreamView)
      this.markHidden(this.event.sourceEvent, true);
  }

  // Getters
  public get timelineData() {
    return this.$timelineData();
  }
  public get isVisible() {
    // Show non hidden and if only single event is hidden
    return (
      !this.isHidden ||
      (this.isSelfFirstHidden && this.countOfNextHiddenEvents === 0)
    );
  }

  public get dateFormat() {
    return this.$timelineMethods.getDateFormat(this.event);
  }

  public get isSelfFirstHidden() {
    // Previous one is visible and this is hidden means this is first hidden
    if (!this.prevEvent) return false;
    return this.isHidden && !this.prevEvent.isHidden;
  }

  public get isNextHidden() {
    if (!this.nextEvent) return false;
    return this.nextEvent?.isHidden;
  }

  public get isPrevSame() {
    return this.$timelineMethods.isSameEvent(this.event, this.prevEvent);
  }

  public get isHidden() {
    return this.event.isHidden;
  }

  public get wasHidden() {
    return this.event.wasHidden;
  }

  public get nextHiddenEvents() {
    const index = this.timelineData.mappedEvents.findIndex(
      e => e.id === this.event.id
    );
    const result: any[] = [];
    for (let i = 0; i < this.timelineData.mappedEvents.length; i++) {
      const event = this.timelineData.mappedEvents[i];
      if (i <= index) continue;
      if (i > index && !event.isHidden) return result;
      if (event.isHidden) result.push(event);
    }
    return result;
  }

  public get countOfNextHiddenEvents() {
    return this.nextHiddenEvents.length;
  }

  // Methods
  public showNextHiddenEvents() {
    this.markHidden(this.event, false);

    this.nextHiddenEvents.forEach(e => {
      this.markHidden(e, false);
    });
  }

  public markHidden(event, isHidden) {
    this.$timelineMethods.markHidden({
      event,
      isHidden
    });
  }

  public onClick(e, event) {
    if (event.onClick) {
      e.stopImmediatePropagation();
      e.preventDefault();
      event.onClick(event);
    }
  }
}
